import { useState, useEffect } from "react";
import { getCurrencyAmount } from "../../../utils/stringUtils";
import {
  IoFileTrayFullOutline,
  IoPeopleOutline,
  IoReceiptOutline,
} from "react-icons/io5";
import dashboardService from "../../../services/dashboardService";

const Overview = () => {
  const [totalAccounts, setTotalAccounts] = useState("-");
  const [invoiceIssued, setInvoiceIssued] = useState("-");
  const [paymentReceived, setPaymentReceived] = useState("-");

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      const { result } = await dashboardService.getTotalAccountAsync();

      if (mounted) setTotalAccounts(result);
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      const { result } = await dashboardService.getTotalInvoiceAmountAsync();
      if (mounted) setInvoiceIssued(getCurrencyAmount(result));
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      const { result } = await dashboardService.getTotalPaymentAmountAsync();
      if (mounted) setPaymentReceived(getCurrencyAmount(result));
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="card p-0">
      <div className="grid grid-cols-3">
        <div className="col-span-1 p-5">
          <div className="flex items-center">
            <IoReceiptOutline className="text-2xl text-gray-400" />
            <div className="ml-4">
              <p className="text-blue-400 tracking-widest uppercase font-semibold text-xs">
                Invoice Issued
              </p>
              <span className="text-gray-400">{invoiceIssued}</span>
            </div>
          </div>
        </div>
        <div className="col-span-1 p-5 border-l border-r">
          <div className="flex items-center">
            <IoFileTrayFullOutline className="text-2xl text-gray-400" />
            <div className="ml-4">
              <p className="text-blue-400 tracking-widest uppercase font-semibold text-xs">
                Payment Received
              </p>
              <span className="text-gray-400">{paymentReceived}</span>
            </div>
          </div>
        </div>
        <div className="col-span-1 p-5">
          <div className="flex items-center">
            <IoPeopleOutline className="text-2xl text-gray-400" />
            <div className="ml-4">
              <p className="text-blue-400 tracking-widest uppercase font-semibold text-xs">
                Total Accounts
              </p>
              <span className="text-gray-400">{totalAccounts}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
